import React from 'react';
/*
 * Loads general user info into state, then supplements it with SMS opt-in info from an AJAX call.
 * Should be converted to a custom hook when the associated controllers are.
 *
 * Once UserSmsInfoMixin.js can be migrated to a Hook, we could update this Hook to take an optional callback.
 * to load additional info and have it use this one. It would pass a callback that loads the SMS info.
 */

import { onSignInOutExecute } from '../onSignInOutExecute.js';


/**
 * @return {[*]} The user object if applicable, or null if not
 * The initial value will always be undefined, indicating we don't yet know whether the user is logged in.
 * We start with the undefined state because we want initial page loads to match server-rendered content,
 * which won't have user info (at least for cached pages).
 * So a null means we know there's no user, whereas undefined means the data hasn't been initialized yet.
 */
export const useUserInfo = function () {
    const [user, setUser] = React.useState(undefined);

    function handleSignin() {
        /* global isLoggedInOrRemembered userObj */
        const userInfo = isLoggedInOrRemembered() ? userObj : null;
        setUser(userInfo);
    }

    React.useEffect(() => {
        // I added this userCookiesReset handling because of a weird states we can get into
        // where the user info gets out of sync with login-related cookies. The only version of that
        // I can reproduce is when I log in on one env (e.g. prod) and then load the page in another env
        // (e.g. staging). I'll briefly start with user into, but it'll get cleared out without this
        // Hook realizing I'm not longer logged in.
        // It's clear actual users are encountering similar situations with the info getting out of sync,
        // but I'm not exactly sure how or how to repro. It's only on some edge cases.
        //
        // This serves as a refresh to make us realize there's no user info, although I'm not sure
        // it's the *best* trigger to use for that. It's hard to track down everything.
        // It might be better to start using react-cookie instead of listening for various
        // DOM events, but that would require more work and bringing in a new library.
        // It could be done as a followup.
        $(window).on('userCookiesReset', handleSignin);
        const cancel = onSignInOutExecute(handleSignin);
        handleSignin();

        return () => {
            cancel();
            $(window).off('userCookiesReset', handleSignin);
        };
    }, []);

    return [user];
};
